/* eslint-disable @typescript-eslint/no-explicit-any */
import { SlButton, SlIcon, SlTooltip } from "@shoelace-style/shoelace";

export class SmartTableFilterButton extends HTMLElement {
  public label = "Filter Preview";
  public buttonLabel = "";

  private _btn: SlButton;
  private _icon: SlIcon;
  private _iconSuffix: SlIcon;
  private _tooltip: SlTooltip;
  private _filterWrapper: HTMLDivElement;

  private attachedEvents = false;

  public openDialog: undefined | (() => void) = undefined;

  constructor() {
    super();

    this._btn = document.createElement("sl-button");
    this._btn.className = "smart-table-filter-by-column-conf";
    this._btn.setAttribute("data-id", `${Math.round(Math.random() * 1000)}`);
    this._btn.variant = "primary";
    this._btn.outline = true;

    this._icon = document.createElement("sl-icon");
    this._icon.name = "funnel";

    this._iconSuffix = document.createElement("sl-icon");
    this._iconSuffix.name = "lightning-charge-fill";

    this._tooltip = document.createElement("sl-tooltip");

    this._filterWrapper = document.createElement("div");
    this._filterWrapper.className = "filter-button-wrapper";
  }

  private attachEvents() {
    if (this.attachedEvents) return;

    this._btn.addEventListener("click", () => {
      if (this.openDialog) {
        this.openDialog();
      } else {
        console.warn("openDialog is not set");
      }
    });

    this.attachedEvents = true;
  }

  connectedCallback() {
    const filterWrapper = this._filterWrapper;
    const btn = this._btn;
    const icon = this._icon;
    const iconSuffix = this._iconSuffix;
    const tooltip = this._tooltip;

    btn.appendChild(icon);
    btn.appendChild(iconSuffix);

    tooltip.content = this.label;

    tooltip.appendChild(btn);
    filterWrapper.appendChild(tooltip);

    this.appendChild(filterWrapper);

    this.attachEvents();
  }

  public updateButtonState = (isEmpty: boolean) => {
    const filterHasConditions = !isEmpty;
    const btn = this._btn;
    const icon = this._icon;

    if (filterHasConditions) {
      btn.variant = "success";
      btn.outline = false;
      icon.name = "funnel-fill";
    } else {
      btn.variant = "primary";
      btn.outline = true;
      icon.name = "funnel";
    }
  };
}

customElements.define("smart-table-filters-button", SmartTableFilterButton);

declare global {
  interface HTMLElementTagNameMap {
    "smart-table-filters-button": SmartTableFilterButton;
  }
}
